module.exports = __webpack_public_path__ + "static/media/broom.8a603f21.svg";